export default {
  setVariables(state, variables) {
    state.variables = variables
  },
  setCurrentModel(state, currentModel) {
    state.currentModel = currentModel
  }
}
